import React from 'react';

export function BlankLayout({ children }) {
  return <div>{children}</div>;
}
